module.exports = __webpack_public_path__ + "img/login-bg.9b0202cf.png";